"use client";
import Image from "next/image";
import Link from "next/link";
import { Layout } from "@/components/Layout/Layout";
import { HeroBanner } from "@/components/HeroBanner/HeroBanner";
import { SectionHeading } from "@/components/SectionHeading/SectionHeading";
import { Heading } from "@/components/Heading/Heading";
import { Paragraph } from "@/components/Paragraph/Paragraph";
import { getImageSrc } from "@/app/utils/getImageSrc";
import HTMLReactParser from "html-react-parser";
import dayjs from "dayjs";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay} from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const jsonLd = {
    "@context": "https://schema.org",

    "@type": "Person",

    name: "Ratul Puri",

    alternateName: "Ratul Puri Kamal Nath",

    url: "https://www.example.com/ratulpuri-kamalnath",

    image: "https://www.example.com/images/ratul-puri.jpg",

    description:
        "Ratul Puri is the nephew of Kamal Nath, a prominent Indian politician and former Chief Minister of Madhya Pradesh.",

    relatedTo: {
        "@type": "Person",

        name: "Kamal Nath",

        jobTitle: "Politician",

        url: "https://en.wikipedia.org/wiki/Kamal_Nath",
    },

    jobTitle: "Chairman",

    worksFor: {
        "@type": "Organization",

        name: "Hindustan Powerprojects Private Limited",

        url: "https://www.hindustanpowerprojects.com",
    },

    sameAs: [
        "https://www.linkedin.com/in/ratulpuri/",

        "https://en.wikipedia.org/wiki/Ratul_Puri",
    ],
};
export default function Wrapper({ pageData, testimonials, initiatives }) {
    return (
        <Layout>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
            />
            <HeroBanner
                image={getImageSrc(pageData.banner.image.url)}
                title={pageData.banner.title}
                about={HTMLReactParser(pageData.banner.text)}
                mobileImage={getImageSrc(pageData.banner.mobileImage.url)}
                alt={pageData.banner.image?.alt || "Hindustan Power CSR initiatives"}
                mobileAlt={pageData.banner.mobileImage?.alt || "Hindustan Power CSR initiatives"}
            />
            <section className="py-8 lg:py-16">
                <div className="hp-container">
                    <div className="text-center flex flex-col gap-8 mb-5">
                        <Heading>
                            {HTMLReactParser(pageData.section2.title)}
                        </Heading>
                        <Paragraph>
                            {HTMLReactParser(pageData.section2.text)}
                        </Paragraph>
                    </div>
                </div>

                <div className="hp-container grid grid-cols-2 lg:grid-cols-4 items-start lg:gap-12 pt-12">
                    <div className="flex flex-col items-start justify-bewteen gap-1 border-b min-h-[280px] md:min-h-auto pb-6 lg:border-b-0 border-r pr-6 lg:pr-12 border-[#EEEEEE]">
                        <h4 className="text-[24px] lg:text-[30px] font-medium flex flex-col">
                            {pageData.section2.blocks[0].title}
                            <span className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal">
                                {pageData.section2.blocks[0].subTitle}
                            </span>
                        </h4>
                        <div className="h-[1px] bg-red w-full my-3"></div>
                        <p className="text-[14px] lg:text-[14px] font-light text-black">
                            {pageData.section2.blocks[0].text}
                        </p>
                    </div>
                    <div className="flex flex-col items-start justify-bewteen gap-1 lg:border-r pl-6 lg:pl-0 lg:pr-12 border-[#EEEEEE] pb-6 lg:pb-0 lg:border-b-0 border-b min-h-[280px] md:min-h-auto">
                        <h4 className="text-[24px] lg:text-[30px] font-medium flex flex-col">
                            {pageData.section2.blocks[1].title}
                            <span className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal">
                                {pageData.section2.blocks[1].subTitle}
                            </span>
                        </h4>
                        <div className="h-[1px] bg-red w-full my-3"></div>
                        <p className="text-[14px] lg:text-[14px] font-light text-black">
                            {pageData.section2.blocks[1].text}
                        </p>
                    </div>
                    <div className="flex flex-col items-start justify-bewteen gap-1 border-r pt-6 lg:pt-0 pr-6 lg:pr-12 border-[#EEEEEE] min-h-[280px] md:min-h-auto">
                        <h4 className="text-[24px] lg:text-[30px] font-medium flex flex-col">
                            {pageData.section2.blocks[2].title}
                            <span className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal">
                                {pageData.section2.blocks[2].subTitle}
                            </span>
                        </h4>
                        <div className="h-[1px] bg-red w-full my-3"></div>
                        <p className="text-[14px] lg:text-[14px] font-light text-black">
                            {pageData.section2.blocks[2].text}
                        </p>
                    </div>
                    <div className="flex flex-col items-start justify-bewteen gap-1 pt-6 lg:pt-0 pl-6 lg:pl-0 min-h-[280px] md:min-h-auto">
                        <h4 className="text-[24px] lg:text-[30px] font-medium flex flex-col">
                            {pageData.section2.blocks[3].title}
                            <span className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal">
                                {pageData.section2.blocks[3].subTitle}
                            </span>
                        </h4>
                        <div className="h-[1px] bg-red w-full my-3"></div>
                        <p className="text-[14px] lg:text-[14px] font-light text-black">
                            {pageData.section2.blocks[3].text}
                        </p>
                    </div>
                </div>
            </section>

            <section className="py-16 bg-blue">
                <div className="hp-container flex flex-col items-center gap-8">
                    <div className="flex flex-col items-center w-full">
                        <SectionHeading
                            heading={pageData.initiatives.title}
                            subHeading={<> Our CSR initiatives focus on inclusive development, community empowerment and creating lasting positive impact. <br/><br/>

Explore inspiring stories of transformation that reflect the positive change our initiatives are bringing to individuals and communities.</>}
                        />
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 w-full">
                        {initiatives.map((initiative, key) => {
                            return (
                                <Link
                                    key={key}
                                    href={`/csr/${initiative.slug}`}
                                    className="flex flex-col justify-end items-start text-left bg-white group text-white relative min-h-[350px] lg:min-h-[500px] overflow-hidden group "
                                >
                                    <div className="flex flex-col gap-2 py-12 px-8 z-20 text-left transition-all duration-500">
                                        <h4 className="text-[24px] lg:text-[30px] font-normal leading-[28px]">
                                            {initiative.basic.title}
                                        </h4>
                                        <h6 className="text-[18px]  font-light flex gap-1 items-center">
                                            <span className="underline underline-offset-4">
                                                Learn More
                                            </span>
                                            <Image
                                                alt="Arrow icon"
                                                src="/arrow-right.svg"
                                                width={100}
                                                height={80}
                                                unoptimized
                                                className="w-3 h-3"
                                            />
                                        </h6>
                                    </div>
                                    <div className="absolute h-full w-full bg-black bg-opacity-30 z-10 top-0 left-0"></div>
                                    <Image
                                        alt={initiative.image?.alt || initiative.basic.title}
                                        src={getImageSrc(initiative.image.url)}
                                        width={100}
                                        height={80}
                                        unoptimized
                                        className="w-full h-full object-cover object-top absolute top-0 left-0"
                                    />
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </section>

            <section className="py-16 bg-primary">
                <div className="flex flex-col items-center ">
                    <div className="hp-container flex flex-col items-center mb-8 w-full">
                        <SectionHeading
                            heading={pageData.impactGallery.title}
                            subHeading={pageData.impactGallery.text}
                            className={"text-white"}
                        />
                    </div>

                    <div className="w-full impact-slider px-5 lg:px-0">
                        <Swiper
                            centeredSlides={true}
                            loop={true}
                            pagination={{ clickable: true }}
                            modules={[Navigation]}
                            navigation={{
                                nextEl: ".custom_next",
                                prevEl: ".custom_prev",
                            }}
                            breakpoints={{
                                // when window width is >= 576px
                                576: {
                                    slidesPerView: 1,
                                },
                                // when window width is >= 1024px
                                1024: {
                                    spaceBetween: 0,
                                    slidesPerView: 2.1,
                                },
                                1280: {
                                    spaceBetween: 0,
                                    slidesPerView: 2.1,
                                },
                            }}
                        >
                            {pageData.impactGallery.slides.map((slide, key) => {
                                return (
                                    <SwiperSlide key={key}>
                                        <div className="flex flex-col justify-center items-center slide">
                                            <Image
                                                alt={slide.image?.alt || "Hindustan Power CSR impact gallery"}
                                                src={getImageSrc(
                                                    slide.image.url
                                                )}
                                                width={100}
                                                height={80}
                                                unoptimized
                                                className="w-full rounded-[20px] overflow-hidden h-[400px] lg:h-[500px] object-cover"
                                            />
                                            <h4 className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal text-black leading-[28px] bg-white rounded-[20px] px-5 lg:px-10 py-1 -mt-[18px] hidden ">
                                                {slide.title}
                                            </h4>
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>

                        <div className="flex items-center justify-center gap-5 mt-12">
                            <div className="custom_prev bg-white flex justify-center items-center rounded-[26.35px] px-5 py-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="text-primary w-6 h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                                    />
                                </svg>
                            </div>
                            <div className="custom_next bg-white flex justify-center items-center rounded-[26.35px] px-5 py-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="text-primary w-6 h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="pt-16">
                <div className="hp-container flex flex-col items-center gap-8">
                    <SectionHeading
                        heading={pageData.testimonials.title}
                        subHeading={pageData.testimonials.text}
                    />

                    <div className="w-full beneficiary-slider">
                        <Swiper
                            loop={true}
                            pagination={{ clickable: true }}
							autoplay={{
        						delay: 3000, // 3 seconds
        						disableOnInteraction: false,
        						pauseOnMouseEnter: true,
    							}}
                            modules={[Pagination, Autoplay]}
                            breakpoints={{
                                // when window width is >= 576px
                                576: {
                                    slidesPerView: 1,
                                },
                                // when window width is >= 1024px
                                1024: {
                                    spaceBetween: 50,
                                    slidesPerView: 2,
                                },
                                1280: {
                                    spaceBetween: 50,
                                    slidesPerView: 2,
                                },
                            }}
                        >
                            {testimonials.map((testimonial, key) => {
                                return (
                                    <SwiperSlide key={key}>
                                        <div className="flex flex-col gap-8 justify-start items-start p-8 lg:py-20 lg:px-12 rounded-[15px] bg-blue h-full">
                                            <h4 className="text-[14px] lg:text-[16px] xl:text-[18px]  font-bold text-primary leading-[24px] lg:leading-[28px]">
                                                {testimonial.title}
                                            </h4>
                                            <p className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal">
                                                {testimonial.testimonial}
                                            </p>
                                            <div className="flex justify-between items-center w-full">
                                                <div className="flex gap-2">
                                                    <Image
                                                        alt={testimonial.image?.alt || testimonial.name}
                                                        src={getImageSrc(
                                                            testimonial.image
                                                                .url
                                                        )}
                                                        width={50}
                                                        height={50}
                                                        unoptimized
                                                        className=""
                                                    />
                                                    <div className="flex flex-col">
                                                        <h5 className="text-[14px] lg:text-[16px] xl:text-[18px]  font-medium">
                                                            {testimonial.name}
                                                        </h5>
                                                        <span className="text-[14px] lg:text-[16px] xl:text-[18px]  font-light">
                                                            {
                                                                testimonial.location
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                                {/* <div className="text-gray text-[14px] lg:text-[16px] xl:text-[18px] ">
                                                    <span>
                                                        {dayjs(
                                                            testimonial.publishDate
                                                        ).format("d MMM YYYY")}
                                                    </span>
                                                </div> */}
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                </div>
            </section>

            <section className="pt-0 lg:pt-16 pb-16">
                <div className="hp-container flex flex-col items-center">
                    <SectionHeading heading={pageData.downloads.title} />
                    <div className="flex flex-col lg:flex-row gap-5 lg:gap-8 items-center justify-start">
                        {pageData.downloads.downloads.map((download, key) => {
                            return (
                                <Link
                                    key={key}
                                    className="bg-white text-black py-1.5 px-6 rounded-[30px] font-bold text-[14px] lg:text-[16px] xl:text-[18px]  inline-flex gap-2 justify-center items-center border border-[#D0D0D0] flex-grow-0"
                                    href={getImageSrc(download.doc.url)}
                                    target="_blank"
                                >
                                    <Image
                                        alt="CSR document PDF icon"
                                        src={"/pdf.svg"}
                                        width={30}
                                        height={30}
                                        unoptimized
                                        className="object-contain"
                                    />
                                    <span>{download.title}</span>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </section>
        </Layout>
    );
}
